import {memo, ReactNode} from 'react';
import {
  GuestPanelDivItem,
  GuestPanelLinkItem,
  NavigationStatusTextProps,
} from 'components/GuestsPanel/types';
import {LinkItem, Item} from './styled';

function isLink(arg: GuestPanelLinkItem | GuestPanelDivItem): arg is GuestPanelLinkItem {
  return Boolean((arg as GuestPanelLinkItem).to);
}

type Props = {children: ReactNode; $isLoading?: boolean} & NavigationStatusTextProps &
  (GuestPanelLinkItem | GuestPanelDivItem);

const GuestPanelItem = memo((props: Props) => {
  if (isLink(props)) {
    return <LinkItem {...props} />;
  } else {
    return <Item {...props} />;
  }
});

export {GuestPanelItem};
